module.exports = __webpack_public_path__ + "static/media/rmuti-logo.af7623e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rmuti-logo.png
// module id = 680
// module chunks = 2